import React, { useEffect, useContext, useState } from "react";
//img
import profileImg from "../../../assets/images/png/Profile.png";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import deletePopupImg from "../../../assets/images/png/Group 2@2x.png";
import plusIcon from "../../../assets/images/svg/plusIcon.png";
//css
import classes from "./GstTab.module.css";
//components
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import DateBar from "../../../components/common/DateBar/DateBar";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import PaginantionComponent from "../../../components/common/Pagination/PaginationComponent";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DataTable from "../../../components/common/DataTable/DataTableSorting";
import { Box, Fade, Modal, Zoom } from "@mui/material";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import DSelectInput from "../../../components/Dashboard/DashboardInputs/DSelectInput";
// import DCheckboxInput from "../../../components/Dashboard/DashboardInputs/DCheckboxInput";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
//API
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import { setItemsData } from "../../../features/ItemsDataSlice";
import {
  emptyCheck,
  validateFile,
  validateNumber,
} from "../../../utils/validations";
import { MoreHoriz } from "@mui/icons-material";
import { nextPageClick, previouPageClick } from "../../../utils/pagination";
//custom hooks
import useFetchData from "../../../hooks/useFetchData";
import DFileUpload from "../../../components/Dashboard/DashboardInputs/DFileUpload";
import DefaultLabel from "../../../components/Dashboard/DefaultLabel/DefaultLabel";
//smaple xl/ csv file for download
import sampleCSV from "../../../assets/files/Sample Tax CSV.xlsx";
import { saveAs } from "file-saver";
import unspscCodes from "../../../data/unspsc.json";
import hsnCodes from "../../../data/hsn.json";
import { getUniqueData } from "../../../utils/getUniqueData";
import ProfileCard from "../../../components/common/ProfileCard/ProfileCard";
import { CurrencyContext } from "../../../context/CurrencyContext";
import SelectCountry from "../../../components/Dashboard/amount/SelectCountry";

const GstTab = () => {
  //dispatcher
  const dispatch = useDispatch();

  //get data from use selector
  const data = useSelector((state) => state.loginData.value);
  const buyer_token = data?.user?.token;

  // const itemsData = '';

  //popuptext
  const [popupHeroText, setPopupHeroText] = useState("");
  const [popupMessage, setPopupMessage] = useState("");

  //search filtered data
  const [searchQuery, setSearchQuery] = useState("");

  const [sortingColumnName, setSortingColumnName] = useState(null);
  const [sortingOrder, setSortingOrder] = useState(null);
  const order =
    sortingOrder === null || sortingOrder === "asc" ? "desc" : "asc";
  //unique user
  const [uniqueData, setUniqueData] = useState();
  const [uniqueDataID, setUniqueDataID] = useState("");

  //credentials
  const [auth_token, setAuthToken] = useState(data?.auth_token);
  const [user_token, setUserToken] = useState(data?.user?.user_token);
  const [org_token, setOrgToken] = useState(data?.user?.token);
  const [pageNumber, setPageNumber] = useState(1);

  //pagination data
  const [paginationData, setPaginationData] = useState();

  //get org users
  const [users, setUsers] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [userError, setUserError] = useState(false);
  const [orgName, setOrgName] = useState();
  const [orgId, setOrgId] = useState();
  const [configUsers, setConfigUsers] = useState([]);

  //pagination logics
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = paginationData?.current_page_count;
  const totalItems = paginationData?.page_count;

  //btn label
  const [loadingState, setLoadingState] = useState(false);
  const [loadingStateDwnload, setLoadingStateDwnload] = useState(false);

  //button label
  const [primaryBtnLabel, setPrimaryBtnLabel] = useState();

  //toggle add/update actions
  const [itemsAction, setItemsAction] = useState({
    addItem: false,
    updateItem: false,
    addBulkItem: false,
  });

  const [UNSPSCList, setUNSPSCList] = useState(
    unspscCodes?.map((e) => e.commodity + " - " + e.commodity_name)
  );
  const [HSNList, setHSNList] = useState(
    hsnCodes?.map((e) => e.hsn_code + " - " + e.description)
  );

  // error message
  const [primaryBtnError, setPrimaryBtnError] = useState({
    error: false,
    errorMsg: "",
  });
  const [tableProps, setTableProps] = useState({
    isLoading: false,
    errorMessage: "",
  });

  const [approvers, setApprovers] = useState([]);

  const { fromCurrency, setFromCurrency } = useContext(CurrencyContext);

  const regexForAlphabets = /[^a-zA-Z\s]/g;
  const regexForAlphaNumeric = /[^a-zA-Z0-9\s]+/g;
  const specialAlphaNumericRegex = /^[a-zA-Z0-9\s\W]+$/;
  const regexForNumber = /[^\d\s]/g;

  const GetUserList = async () => {
    await axios({
      url: `${API_ENDPOINT.user_list}`,
      method: "POST",
      data: {
        user_token: user_token,
      },
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setUsers(res.data.user_list);
        setOrgName(res.data.org_name);
        setOrgId(res.data.org_id);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const GetConfigList = async () => {
    const formData = new FormData();
    formData.append("org_id", orgId);
    formData.append("search", searchQuery);
    formData.append("buyer_token", buyer_token);
    formData.append("page", pageNumber);
    await axios({
      url: `${API_ENDPOINT.gst_list}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setConfigUsers(res.data.results);
        const { page_count, total_count, current_page_count } = res.data;
        const totalItems = total_count;
        const currentPage = pageNumber || 1;
        setPaginationData({
          currentPage,
          totalItems,
          current_page_count,
          page_count,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  const itemsData = configUsers;

  const userOptions = {
    values: {
      tokens: users?.map((user) => user.id) || [],
      visibleOption: users?.map((user) => user.full_text) || [],
    },
  };

  const initializeSelectedApprovers = (existingEmails) => {
    const defaultApproverEmail = existingEmails[0] || "";
    const defaultApproverId =
      userOptions.values.tokens[
        userOptions.values.visibleOption.indexOf(defaultApproverEmail)
      ] || "";

    const dynamicApprovers = existingEmails.slice(1).map((full_text, index) => {
      const emailId =
        userOptions.values.tokens[
          userOptions.values.visibleOption.indexOf(full_text)
        ];
      return {
        id: emailId,
        value: full_text,
        showPlus: index === existingEmails.length - 2,
      };
    });
    setApprovers(dynamicApprovers);
  };

  // const GetAllData = () => {
  //   useFetchData({
  //     pageNumber: pageNumber,
  //     endpoint: `${API_ENDPOINT.projects_list}`,
  //     idName: "org_token",
  //     idValue: org_token,
  //     searchQuery: searchQuery,
  //     ...(sortingColumnName && { sortingColumnName: sortingColumnName }),
  //     ...(sortingOrder && { sortingOrder: order }),
  //     auth_token: auth_token,
  //     setData: setItemsData,
  //     setPaginationData: setPaginationData,
  //     dispatch: dispatch,
  //     tableProps,
  //     setTableProps,
  //   });
  // };

  let delay = 300;

  //get users data for table view
  useEffect(() => {
    let timeoutId = null;

    timeoutId = setTimeout(() => {
      if (pageNumber) {
        // GetAllData();
      }
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [pageNumber, searchQuery, sortingColumnName, sortingOrder]);

  useEffect(() => {
    GetUserList();
    setPrimaryBtnLabel(
      itemsAction.addItem
        ? "Add"
        : itemsAction.updateItem
        ? "Update"
        : itemsAction.addBulkItem
        ? "Add"
        : ""
    );
  }, [itemsAction]);

  useEffect(() => {
    if (orgId) {
      GetConfigList();
    }
  }, [orgId, searchQuery, pageNumber]);

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, buyerAdmin_master_search } = JSON.parse(chatActionRaw);

    if (action === "search_tax_master") {
      if (!itemsData || itemsData.length === 0) return;

      console.log(buyerAdmin_master_search?.searchText);
      setSearchQuery(buyerAdmin_master_search?.searchText || "");
      setPageNumber(1);

      sessionStorage.removeItem("CHAT_ACTION");
    }

    if (action === "add_tax_master") {
      handleOpenAddItem();
    }
  }, [itemsData]);

  const updateInputs = (data) => {
    setgst((prev) => ({
      ...prev,
      value: data?.gst,
    }));

    if (data?.users?.length > 0) {
      const remainingApprovers = data.users.slice(1).map((user, index) => ({
        value: user,
        id: userOptions.values.tokens[
          userOptions.values.visibleOption.indexOf(user)
        ],
        isValid: true,
        showPlus: index === data.users.length - 2,
      }));

      setApprovers(remainingApprovers);
    } else {
    }
    setFromCurrency((prev) => ({
      ...prev,
      currency: data?.currency_type,
      countryName: data?.country_name && data?.country_name,
    }));
  };

  //demo data for the datatable
  const headings = [
    { label: "Tax", field: "gst" },
    { label: "Country", field: "country_name" },
  ];

  // modal states
  const [open, setOpen] = useState(false);

  const handleOpenAddItem = () => {
    setOpen(true);
    resetForm();
    setItemsAction({
      addItem: true,
      updateItem: false,
    });
  };

  const handleOpenAddBulkItem = () => {
    setOpen(true);
    resetForm();
    setItemsAction({
      addItem: false,
      updateItem: false,
      addBulkItem: true,
    });
  };

  const handleOpenEditItem = (unique_id) => {
    setOpen(true);
    // resetForm();
    let rowData = getUniqueData(itemsData, "id", unique_id);
    rowData = {
      ...rowData,
      users: rowData.users
        ? rowData.users.map((user) => user.full_text.trim())
        : [],
    };
    const existingApproversEmails = rowData.users;
    initializeSelectedApprovers(existingApproversEmails);

    updateInputs(rowData);
    setUniqueDataID(unique_id);
    setItemsAction({
      addItem: false,
      updateItem: true,
    });
  };

  const handleClose = () => {
    setOpen(false);
    setPrimaryBtnError({
      error: false,
      errorMsg: "",
    });
    setApprovers([]);
  };

  // S - success popup
  const [openS, setOpenS] = useState(false);
  const handleOpenS = () => {
    setOpenS(true);
  };
  const handleCloseS = () => {
    setOpenS(false);
  };

  // VU - View User popup
  const [openViewItemPopup, setOpenViewItemPopup] = useState(false);
  const handleOpenViewItemPopup = (unique_id) => {
    let rowData = getUniqueData(itemsData, "id", unique_id);
    setUniqueData(rowData);

    setOpenViewItemPopup(true);
  };
  const handleCloseViewItemPopup = () => {
    setOpenViewItemPopup(false);
  };

  // viewItemsActionButtons
  const viewItemsActionButtons = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseViewItemPopup}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <DButton
      label={"OK"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={handleCloseViewItemPopup}
    />,
  ];
  const viewUserChildren = [
    <InfoLabel
      size={"44%"}
      label={"Country"}
      value={uniqueData?.country_name}
    />,
    <InfoLabel size={"44%"} label={"Gst"} value={uniqueData?.gst} />,
    <InfoLabel />,
  ];

  const viewUserHeading = (
    <HeaderTitle
      titleText={uniqueData?.gst || <MoreHoriz sx={{ fontSize: "30px" }} />}
      customclass={classes.VUpopupHeading}
    />
  );

  //common states for CRUD
  const [itemName, setItemName] = useState({
    value: "",
    isValid: true,
  });
  const [itemCode, setItemCode] = useState({
    value: "",
    isValid: true,
  });
  const [csvFile, setCsvFile] = useState({
    value: "",
    isValid: true,
  });
  const [user, setUser] = useState({
    value: "",
    isValid: true,
  });

  const [gst, setgst] = useState({
    value: "",
    isValid: true,
  });

  const [existingVendorList, setExistingVendorList] = useState([]);

  const resetForm = () => {
    setItemCode({
      value: "",
      isValid: true,
    });
    setgst({
      value: "",
      isValid: true,
    });
    setItemName({
      value: "",
      isValid: true,
    });
    setCsvFile({
      value: "",
      isValid: true,
    });
    setgst({
      value: "",
      isValid: true,
    });
  };

  const validateForm = (query) => {
    const isgst = emptyCheck(gst.value);

    const isCsvFile = validateFile(
      csvFile.value,
      false,
      ["csv", "xlsx"],
      5
    ).isValid;
    setgst((prev) => ({
      ...prev,
      isValid: isgst,
    }));

    if (query === "bulkData") {
      setCsvFile((prev) => ({
        ...prev,
        isValid: isCsvFile,
      }));

      return isCsvFile;
    } else {
      return isgst;
    }
  };

  // ADD Item function
  const addItem = async () => {
    const dynamicApproversIDs =
      approvers.length > 0
        ? approvers.map((approver) => approver.id).filter(Boolean)
        : "";

    const formData = new FormData();
    formData.append("id", "");
    formData.append("org_id", orgId);
    formData.append("gst", gst.value);
    formData.append("currency", fromCurrency.currency);
    formData.append("country_name", fromCurrency.countryName);

    await axios({
      url: `${API_ENDPOINT.add_gst}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        // GetAllData();
        setPopupHeroText("Tax Added!");
        setPopupMessage(res?.data?.response);
        handleOpenS();
        handleClose();
        resetForm();
        setLoadingState(false);
        // setSelectedApprovers('')
        setApprovers("");
        GetConfigList();
      })
      .catch((err) => {
        setPrimaryBtnError({
          error: true,
          errorMsg: Object.values(err?.response?.data)[0],
        });
        setLoadingState(false);
      });
  };

  // ADD Bulk Items function
  const addBulkItems = async () => {
    const formData = new FormData();

    formData.append("org_token", org_token);
    formData.append("csv_file", csvFile.value);

    await axios({
      url: `${API_ENDPOINT.tax_bulk_add}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        // GetAllData();
        setPopupHeroText("Items Added!");
        setPopupMessage(res?.data?.response);
        handleOpenS();
        handleClose();
        resetForm();
        setLoadingState(false);
      })
      .catch((err) => {
        setPrimaryBtnError({
          error: true,
          errorMsg:
            (typeof err?.response?.data?.response !== "object" &&
              err?.response?.data?.response) ||
            "Something went wrong! please check the file values & try again.",
        });
        setLoadingState(false);
      });
  };

  // Update item submit click
  const updateItem = async () => {
    // const defaultApproverID = selectedApprovers.id;
    const dynamicApproversIDs = approvers
      .map((approver) => approver.id)
      .filter(Boolean);
    // const approversIDs = [defaultApproverID, ...dynamicApproversIDs];
    const formData = new FormData();
    formData.append("id", uniqueDataID);
    formData.append("org_id", orgId);
    formData.append("gst", gst.value);
    formData.append("currency", fromCurrency.currency);
    formData.append("country_name", fromCurrency.countryName);

    await axios({
      url: `${API_ENDPOINT.add_gst}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        // GetAllData();
        setPopupHeroText("Tax Updated!");
        setPopupMessage(res?.data?.response);
        handleClose();
        handleOpenS();
        resetForm();
        setLoadingState(false);
        GetConfigList();
        setApprovers("");
      })
      .catch((err) => {
        console.log(err);
        setPrimaryBtnError({
          error: true,
          errorMsg: Object.values(err?.response?.data)[0],
        });
        setLoadingState(false);
      });
  };

  //submit click ADD/UPDATE item
  const handleSubmit = () => {
    const validation = itemsAction.addBulkItem
      ? validateForm("bulkData")
      : validateForm();
    if (validation) {
      if (itemsAction.addItem) {
        setLoadingState(true);
        addItem();
      } else if (itemsAction.updateItem) {
        setLoadingState(true);
        updateItem();
      } else if (itemsAction.addBulkItem) {
        setLoadingState(true);
        addBulkItems();
      }
    } else {
      setItemName((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setItemCode((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setCsvFile((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setgst((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setUser((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
    }
  };

  //category select options
  const selectCategory = ["Select", "IT", "Stationary"];

  // INPUTS
  const InputsHeading = (
    <HeaderTitle
      titleText={
        itemsAction.addItem
          ? "Add Tax"
          : itemsAction.updateItem
          ? "Update Tax"
          : itemsAction.addBulkItem
          ? "Bulk item upload"
          : ""
      }
      customclass={classes.popupHeading}
    />
  );
  const ItemInputs = [
    <SelectCountry
      customClass={classes.approvercountry}
      value={fromCurrency}
      setValue={setFromCurrency}
      label="Country"
      size={"45%"}
      width={true}
      margin={"1rem"}
      onChange={(newCurrency) => {
        setFromCurrency({
          ...newCurrency,
        });
      }}
      disableUpd={itemsAction.updateItem}
    />,

    <DTextInput
      label="Tax"
      type="text"
      maxLength={250}
      value={gst.value}
      onChange={(e) => {
        const re = /^[0-9\b]+$/;
        let val = e.target.value;
        if (val === "" || re.test(val)) {
          setgst({
            value: val,
            isValid: emptyCheck(e.target.value),
          });
        }
      }}
      error={!gst.isValid}
      customClassName={classes.popupFields}
      errorMsg={"Tax is required"}
      size={"45%"}
    />,

    //   <SelectCountry
    //   customClassName={`${classes.field} ${"signup-country-code"}`}
    //   value={fromCurrency}
    //   setValue={setFromCurrency}
    //   label="Country"
    //   showCountryName={true}
    // />,

    <></>,
  ];

  const BulkItemInputs = [
    <div className={classes.input_container}>
      <DefaultLabel label={"Upload file"} />
      <DFileUpload
        fileTypes={".xlsx,.csv"}
        customFileTypeText={"(Supported format CSV, XLSX)"}
        onFileUpload={(file) => {
          let isFileValid = validateFile(
            file,
            false,
            ["csv", "xlsx"],
            5
          ).isValid;
          setCsvFile({
            value: file,
            isValid: isFileValid,
          });
        }}
        error={!csvFile.isValid}
        errorMsg={
          validateFile(csvFile.value, false, ["csv", "xlsx"], 5, "CSV file")
            .errorMessage
        }
        size={"100%"}
      />
      <p
        className={classes.linkBtn}
        onClick={() => {
          saveAs(sampleCSV, "Sample CSV");
        }}
      >
        Sample CSV
      </p>
    </div>,
  ];

  const itemsActionsButton = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleClose}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <DButton
      label={primaryBtnLabel}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      loadingState={loadingState}
      error={primaryBtnError.error}
      errorMsg={primaryBtnError.errorMsg}
      onClick={handleSubmit}
    />,
  ];

  //deletion popups and functions
  const deleteItem = async (deletionType) => {
    let isHardDelete = deletionType && deletionType === "hard delete";
    setLoadingState(true);

    setPopupMessage("");

    if (isHardDelete) {
      const formData = new FormData();
      formData.append("id", uniqueDataID);
      formData.append("status", "3");
      formData.append("org_id", orgId);
      formData.append("gst", gst.value);
      formData.append("currency", "");
      formData.append("country_name", "");

      await axios({
        method: "POST",
        url: `${API_ENDPOINT.add_gst}`,
        data: formData,
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      })
        .then((res) => {
          // GetAllData();
          handleCloseDltConfirmation();
          setPopupHeroText(`Tax Deleted Successfully!`);
          setPopupMessage(res?.data?.response);
          setLoadingState(false);
          GetConfigList();
        })
        .catch((err) => {
          setPopupHeroText("OOPS! Something went wrong");
          setPopupMessage(err?.response?.data?.response);
          console.log(err);
          setLoadingState(false);
        });
    } else {
      await axios({
        method: "POST",
        url: `${API_ENDPOINT.delete_item}`,
        data: {
          token: uniqueDataID,
          status: itemStatus,
        },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      })
        .then((res) => {
          // GetAllData();
          handleCloseDltConfirmation();
          setPopupHeroText(
            `Item ${itemStatus ? "Activated!" : "Deactivated!"}`
          );
          setPopupMessage(res?.data?.response);
          setLoadingState(false);
        })
        .catch((err) => {
          setPopupHeroText("Something went wrong!");
          setPopupMessage(err?.response?.data?.response);
          console.log(err);
          setLoadingState(false);
        });
    }
  };

  //delete data
  const [openDlt, setOpenDlt] = useState(false);
  const handleOpenDlt = () => setOpenDlt(true);
  const handleCloseDlt = () => {
    setOpenDlt(false);
  };
  const [openDltConfirmation, setOpenDltConfirmation] = useState(false);
  const [itemStatus, setItemStatus] = useState();

  const [itemHardDelete, setItemHardDelete] = useState(false);

  const handleOpenDltConfirmation = (deletion_id, rowData, deletionType) => {
    let isHardDelete = deletionType && deletionType === "hard delete";
    setItemHardDelete(isHardDelete);
    let popupMsg = rowData.status
      ? "Are you sure want to deactivate"
      : "Are you sure want to activate";
    let status = !rowData.status;
    let uniqueData = getUniqueData(itemsData, "id", deletion_id);
    setPopupHeroText(
      `${isHardDelete ? "Are you sure want to delete" : popupMsg} "${
        uniqueData?.gst
      }"?`
    );
    setOpenDltConfirmation(true);
    setUniqueDataID(deletion_id);
    setItemStatus(status);
  };
  const handleCloseDltConfirmation = () => {
    setOpenDltConfirmation(false);
    setItemHardDelete(false);
  };
  const handleDeleteUser = () => {
    handleOpenDlt();
    itemHardDelete ? deleteItem("hard delete") : deleteItem();
    handleCloseDltConfirmation();
  };

  return (
    <div className={classes.users_tab_wrapper}>
      <div className={classes.users_topHeader}>
        <div className={`${classes.lhs} ${classes.flex}`}>
          <HeaderTitle titleText="Tax Master" customclass={classes.dashHead} />
        </div>

        {/* <div className={`${classes.notificationBar}`}>
          <DateBar />
          <ProfileCard
            imageSrc={profileImg}
            profilePath={"/Organization_dashboard/My_profile"}
          />
        </div> */}
      </div>

      <div className={classes.search_add_wrapper}>
        <SearchBar
          value={searchQuery}
          onChange={(query) => {
            setSearchQuery(query);
            setPageNumber(1);
          }}
          placeholder="Search by Tax, Country"
        />

        <div
          className={classes.flex}
          style={{
            flexWrap: "wrap",
            justifyContent: "flex-start",
          }}
        >
          <DButtonOutlined
            iconWidth="1rem"
            iconHeight="1rem"
            label="UPLOAD"
            btnHeight="4rem"
            onClick={handleOpenAddBulkItem}
          />
          <DButton
            labelImg={plusIcon}
            iconWidth="1rem"
            iconHeight="1rem"
            label="Add Tax"
            btnHeight="4rem"
            onClick={handleOpenAddItem}
          />
        </div>
      </div>

      <div className={`${classes.d_dataTable}`}>
        <DataTable
          headings={headings}
          tableData={itemsData}
          actions={true}
          
          
          tableSize={itemsData?.length === 0 ? "100%" : "100%"}
          viewBtn={true}
          deleteBtn={true}
          editBtn={true}
          sorting={true}
          viewClick={handleOpenViewItemPopup}
          editClick={handleOpenEditItem}
          toggleOnChange={handleOpenDltConfirmation}
          deleteClick={(id, row) => {
            handleOpenDltConfirmation(id, row, "hard delete");
          }}
          errorMessage={tableProps.errorMessage}
          isLoading={tableProps.isLoading}
          itemsTable={true}
          setSortingColumnName={setSortingColumnName}
          sortingColumnName={sortingColumnName}
          setSortingOrder={setSortingOrder}
          sortingOrder={sortingOrder}
          // stickyFirstColumn={true}
          viewTooltip={"View"}
          editTooltip="Edit"
          deleteTooltip="Delete"
        />

        <PaginantionComponent
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          currentPage={currentPage || 0}
          itemsPerPage={itemsPerPage || 0}
          totalItems={totalItems || 0}
          localStorageKey={"rfq_organ_page_number"}
          previouPageClick={() => {
            previouPageClick(pageNumber, setPageNumber);
          }}
          nextPageClick={() => {
            nextPageClick(pageNumber, setPageNumber, paginationData);
          }}
          disablePrevious={parseInt(pageNumber) === 1 || pageNumber === ""}
          disableNext={
            parseInt(pageNumber) === paginationData?.page_count ||
            !paginationData ||
            pageNumber === ""
          }
        />
      </div>

      {/* modal popups */}

      {/* add/update item modal */}
      <Modal
        open={open}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
        sx={{
          overflow: "auto",
        }}
      >
        <Fade in={open}>
          <div
            className={classes.flex}
            style={{
              height: "130vh",
            }}
          >
            <PopupFrame
              inputChildren={
                itemsAction.addItem
                  ? ItemInputs
                  : itemsAction.updateItem
                  ? ItemInputs
                  : itemsAction.addBulkItem
                  ? BulkItemInputs
                  : ItemInputs
              }
              poupHeading={InputsHeading}
              actionButtons={itemsActionsButton}
              closePopup={handleClose}
              customClass={
                itemsAction.updateItem ? classes.updatePopup : classes.addPopup
              }
              // styleCenterDiv={classes.centerDiv}
            />
          </div>
        </Fade>
      </Modal>

      {/* view user modal */}
      <Modal
        open={openViewItemPopup}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
      >
        <Fade in={openViewItemPopup}>
          <div
            className={classes.flex}
            style={{
              height: "130vh",
            }}
          >
            <PopupFrame
              inputChildren={viewUserChildren}
              poupHeading={viewUserHeading}
              actionButtons={viewItemsActionButtons}
              closePopup={handleCloseViewItemPopup}
              width={"auto"}
              customClass={classes.addPopup}
              styleCenterDiv={classes.centerDiv}
            />
          </div>
        </Fade>
      </Modal>

      {/* success modal */}
      <Modal open={openS}>
        <Fade in={openS}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={popupHeroText}
              popupDescription={popupMessage}
              popBtn={true}
              btnText={"Okay"}
              btnClick={handleCloseS}
            />
          </Box>
        </Fade>
      </Modal>

      {/* delete error modal two states - confirmation and deletion */}

      {/* confirmation */}
      <Modal open={openDltConfirmation}>
        <Fade in={openDltConfirmation}>
          <Box>
            <SuccessPopupDashboard
              popupImage={deletePopupImg}
              popupHeroText={popupHeroText}
              popBtn={true}
              btnText={"Yes"}
              secondaryBtn={true}
              btnTextSecondary={"No"}
              btnClick={handleDeleteUser}
              customHeroTextClass={classes.popupTxtSm}
              btnClickSecondary={handleCloseDltConfirmation}
            />
          </Box>
        </Fade>
      </Modal>

      {/* deletion */}
      <Modal open={openDlt}>
        <Fade in={openDlt}>
          <Box>
            <SuccessPopupDashboard
              popupImage={deletePopupImg}
              popupHeroText={popupHeroText}
              popupDescription={popupMessage}
              popBtn={true}
              btnText={"Okay"}
              loadingPrimaryBtn={loadingState}
              btnClick={handleCloseDlt}
              customHeroTextClass={classes.popupTxtSm}
            />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default GstTab;
